import {
  LogLevel_WARN_getInstance3t76hodk0ofiq as LogLevel_WARN_getInstance,
  get_debugMode2ku08uo1anfv as get_debugMode,
  Log1znm0y8m419dj as Log,
} from './debugger.mjs';
import { Companion_instance1lm8x0jadqh2g as Companion_instance } from './Platform.mjs';
import { get_isDevelopment16qk6tv1fuxkk as get_isDevelopment } from './Platform.js.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  Element$_get_themeChoice_$ref_lsylda2osm2sk65qcho as Element$_get_themeChoice_$ref_lsylda,
  Element$_set_themeChoice_$ref_bp8duq32iz468f7cncf as Element$_set_themeChoice_$ref_bp8duq,
} from './views/Element.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { SetAsBase1p1kkt5i4f45k as SetAsBase } from './models/Theme.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { get_basePath37oh0bkfrtwru as get_basePath } from './navigation/Navigator.js.mjs';
import { DynamicCssr3610hzbsxx2 as DynamicCss } from './views/DynamicCss.js.mjs';
import { KiteUiCsshhimfofutzw8 as KiteUiCss } from './views/KiteUiCss.mjs';
import { ElementContext16kjlmo0pjcp3 as ElementContext } from './views/ElementContext.commonHtml.mjs';
import { ExternalServices_instance8vpkk4rsrb5w as ExternalServices_instance } from './ExternalServices.mjs';
import { get_native16zxqjg6lrtlz as get_native } from './views/NativeElement.commonHtml.mjs';
import { invoke3ik0mg5nfxrhr as invoke } from '../../../../reactive/com/lightningkite/reactive/context/CoroutineScopeHelpers.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KiteUiCoroutineScopeHelpers25rj47zs39igb as KiteUiCoroutineScopeHelpers } from './views/KiteUiCoroutineScopeHelpers.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_getInstance252uiobns9yoh as Companion_getInstance,
  Edges2jf5wl855ambv as Edges,
} from './models/Rect.mjs';
import { set_safeInsets1p7xqcp7roimu as set_safeInsets } from './views/ViewContextExtensions.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from './reactive/AppState.js.mjs';
import { get_dp28ag147e4p5cz as get_dp } from './models/data.commonHtml.mjs';
import { KeyCodes_instance1xpu3tad1ataj as KeyCodes_instance } from './models/KeyCode.commonHtml.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function root(theme, logLevel, app) {
  logLevel = logLevel === VOID ? get_isDevelopment(Companion_instance) ? LogLevel_WARN_getInstance() : null : logLevel;
  // Inline function 'kotlin.run' call
  var $this$run = new (Root())(logLevel, ($this$Root) => {
    var tmp = KMutableProperty0();
    var tmp_0 = Element$_get_themeChoice_$ref_lsylda($this$Root);
    var tmp_1 = getPropertyCallableRef('themeChoice', 0, tmp, tmp_0, Element$_set_themeChoice_$ref_bp8duq($this$Root));
    $this$Root.invoke_bnq13k_k$(tmp_1, ($this$invoke) => new (SetAsBase())($this$invoke.invoke_r7m7el_k$(theme)));
    return Unit_instance;
  });
  if (get_debugMode()) {
    setupDebugSafeInsets($this$run);
  }
  app($this$run);
}
var RootClass;
function Root() {
  if (RootClass === VOID) {
    class $ {
      constructor(logLevel, beforeDocumentAppend) {
        logLevel = logLevel === VOID ? get_isDevelopment(Companion_instance) ? LogLevel_WARN_getInstance() : null : logLevel;
        this.$$delegate_0__1 = get_AppScope();
        this.beforeDocumentAppend_1 = beforeDocumentAppend;
        var tmp = this;
        // Inline function 'kotlin.run' call
        var dynamicCss = new (DynamicCss())(get_basePath());
        var tmp_0 = get_basePath();
        var tmp_1;
        if (logLevel == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = Log('KiteUiCss', logLevel);
        }
        // Inline function 'kotlin.also' call
        var this_0 = new (ElementContext())(tmp_0, dynamicCss, new (KiteUiCss())(dynamicCss, tmp_1));
        ExternalServices_instance.baseContext_1 = this_0;
        tmp.context_1 = this_0;
      }
      get_context_h02k06_k$() {
        return this.context_1;
      }
      willAddChild_hz2iwc_k$(element) {
      }
      addChild_2qpft2_k$(element) {
        this.beforeDocumentAppend_1(element);
        var tmp0_safe_receiver = document.body;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.append(get_native(element).create_md4cuc_k$());
        }
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    protoOf($).invoke_bnq13k_k$ = invoke;
    initMetadataForClass($, 'Root', VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    RootClass = $;
  }
  return RootClass;
}
function setupDebugSafeInsets(_this__u8e3s4) {
  var safe = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(Companion_getInstance().ZERO_1);
  set_safeInsets(_this__u8e3s4.get_context_h02k06_k$(), safe);
  var times = {_v: 0};
  var tmp = AppState_getInstance();
  tmp.onUniversalKeyboard_3hqcjo_k$((it) => {
    var tmp;
    if (it.alt_1 && it.code_1 === KeyCodes_instance.letter_qks4hj_k$(_Char___init__impl__6a9atx(101))) {
      var tmp_0;
      var _unary__edvuaz = times._v;
      times._v = _unary__edvuaz + 1 | 0;
      if ((_unary__edvuaz % 2 | 0) === 0) {
        tmp_0 = Edges().new_com_lightningkite_kiteui_models_Edges_h2jw3i_k$(get_dp(100));
      } else {
        tmp_0 = Companion_getInstance().ZERO_1;
      }
      safe.set_value_v1vabv_k$(tmp_0);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  });
}
//region block: exports
export {
  root as root1l5mhptocagam,
};
//endregion

//# sourceMappingURL=root.mjs.map
